import React from 'react';
import DesktopComments728x90Fs from './freestar/DesktopComments728x90';
const DesktopComments728x90 = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopComments728x90Fs, {
        safety: safety
    });
};
DesktopComments728x90.displayName = 'DesktopComments728x90';
export default DesktopComments728x90;
